import { readOnly } from 'models/restutil';

export class PenOfferStatusDto {
  public static ApiUrl = 'api/pen-offer-statuses';

  Id: number;
  Name: string;
  NameEn: string;
  NameEs: string;
  Created?: Date;
  Updated?: Date;
  @readOnly()
  IsDeleted: boolean;
}
